import { search } from "../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);
const path = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/empresa`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function getSummaryDocumentsConfig({ companyId }) {
  const url = new URL(
    `${path}/${companyId}/configuration/fiscal-documents/summary`
  );

  return search(decodeURIComponent(url), "GET", headers);
}
